import { render, staticRenderFns } from "./TaskTableBody.vue?vue&type=template&id=05322ab0"
import script from "./TaskTableBody.vue?vue&type=script&lang=ts"
export * from "./TaskTableBody.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports